// @flow

import React, { PureComponent } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';

import Console from '../../../lib/debug';

const defaultColumnDefinition = [
    {
        text: 'Error',
        dataField: 'error'
    }
];

type Props = {
    columns: () => void, //required
    rows: () => void, //required
    rowEvents: {},
    defaultSort: Array
};

export default class Table extends PureComponent<Props> {
    render() {
        Console.render('Table');
        const columns = this.props.columns || defaultColumnDefinition;
        const rows = this.props.rows || [];
        const rowEvents = this.props.rowEvents;
        const defaultSort = this.props.defaultSort;

        let rowClasses = 'th-table-row';
        if (rowEvents) {
            rowClasses += ' clickable';
        }

        return (
            <BootstrapTable
                className="th-table"
                keyField="keyField"
                data={rows}
                defaultSorted={defaultSort}
                columns={columns}
                rowClasses={rowClasses}
                rowEvents={rowEvents}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/table/Table.jsx